import workspaceQuery from '../../../graphql/queries/company/CompanyFinancialCalendarWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/company/CompanyFinancialCalendarListQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/CompanyFinancialCalendarQuery.graphql';
import defaultQuery from '../../../graphql/queries/company/CompanyFinancialCalendarDefault.graphql';
import mutationQuery from '../../../graphql/mutations/company/CompanyFinancialCalendarMutation.graphql';
import generateCalendarQuery from '../../../graphql/mutations/company/CompanyGenerateCalendarQueryDefault.graphql';
import fragment from '../../../graphql/fragments/company/FinancialCalendarsFragment.graphql';

const CompanyFinancialCalendar = {
  type: 'FinancialCalendar',
  title: 'Financial Calendars',
  formTitle: 'Financial Calendar',
  formUrl: '/Company/FinancialCalendar/Details/',
  workspaceUrl: '/Company/FinancialCalendar/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  generateCalendarQuery: generateCalendarQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'year',
  },
  fragment,
  screenReference: 'FINANCIAL_CALENDARS',
};

export default CompanyFinancialCalendar;
